import React, { useEffect, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import {
  Container,
  Grid,
  Hidden,
  LinearProgress
} from '@material-ui/core';
import axios from 'axios';
import Filter, { FILTER_SECTION } from '../components/Filter';
import MerchantCard from '../components/MerchantCard';

const useStyles = makeStyles((theme) => ({
  loadingMerchants: {
    display: 'block',
    margin: '0 auto',
    height: '30px',
  },
}));

export default function Home() {
  const classes = useStyles();
  let history = useHistory();
  const [marketState, setMarketState] = React.useState({
    merchants: [],
    initialMerchants: [],
    settings: {
      categories: [],
      locations: [],
      recommendations: [],
    },
    isFirstLoad: true,
  });
  const [loading, setLoading] = React.useState(false);
  
  // lazy loads images with intersection observer
  // only swap out the image source if the new url exists
  const merchantFilter = useRef(null);
  const imgObserver = useCallback(node => {
    const intObs = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.intersectionRatio > 0) {
          intObs.unobserve(node); // detach the observer when done
          // Check if this is a 1st load, we need to set the merchant to be the same as the initial merchants
          if(marketState.isFirstLoad) {
            (async () => {
              const resultSetting = await axios.get(process.env.REACT_APP_API_BASE_URL + '/market/settings');
        
              if (resultSetting.data.settings.siteEnabled === 1) {
                const result = await axios.get(process.env.REACT_APP_API_BASE_URL + '/market/merchants');
                setMarketState((prevState) => {
                  return {
                    ...prevState,
                    initialMerchants: result.data.merchants,
                    merchants: result.data.merchants,
                    settings: result.data.settings,
                  }
                });
              }
              else {
                history.push('/comingsoon', { customMessage: resultSetting.data.settings.customMessage });
              }

              setMarketState((prevState) => {
                return {
                  ...prevState,
                  isFirstLoad: false,
                }
              });
            })();
          }
        }
      });
    })
    intObs.observe(node);
  }, []);

  useEffect(() => {
    merchantFilter.current = document.querySelectorAll('.merchant-filter');
    if (merchantFilter.current) {
      merchantFilter.current.forEach(merchantFilter => {
        imgObserver(merchantFilter);
      });
    }
  }, [imgObserver, merchantFilter]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const resultSetting = await axios.get(process.env.REACT_APP_API_BASE_URL + '/market/settings');

      if (resultSetting.data.settings.siteEnabled === 1) {
        const result = await axios.get(process.env.REACT_APP_API_BASE_URL + '/market/merchants?page=0&size=4');
        setMarketState((prevState) => {
          return {
            ...prevState,
            initialMerchants: result.data.merchants,
            merchants: result.data.merchants,
            settings: result.data.settings,
          }
        });
      }
      else {
        history.push('/comingsoon', { customMessage: resultSetting.data.settings.customMessage });
      }
      merchantFilter.current = document.querySelectorAll('.merchant-filter');
      if (merchantFilter.current) {
        merchantFilter.current.forEach(merchantFilter => {
          imgObserver(merchantFilter);
        });
      }
      setLoading(false);

    })();
  }, []);

  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Hidden smDown>
          <Filter
            filterSection={FILTER_SECTION.DESKTOP}
            marketState={marketState}
            setMarketState={setMarketState}
            setLoading={setLoading}
          />
        </Hidden>
        <Hidden mdUp>
          <Filter
            filterSection={FILTER_SECTION.MOBILE}
            marketState={marketState}
            setMarketState={setMarketState}
            setLoading={setLoading}
          />
        </Hidden>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {loading ?
                <>
                  <LinearProgress color="secondary" />
                </>
                :
                /*marketState.merchants.length + " of " + marketState.initialMerchants.length + " restaurants"*/
                <></>
              }
            </Grid>
            {marketState.merchants.length > 0 ? marketState.merchants.map(merchant => {
              return (
                <Grid item xs={12} md={3} className="merchant-grid" >
                  <MerchantCard merchant={merchant} />
                </Grid>
              )
            })
              : (loading ?
                <div className={classes.loadingMerchants}>Opening The Market...</div>
                :
                <div className={classes.loadingMerchants}>No restaurants, please choose a different filter</div>)
            }
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
}